// Pathify
import { make } from 'vuex-pathify'
import getApiClient from '@/plugins/api-client'

// Data
const state = {
  drawer: null,
  drawerImage: true,
  mini: false,
  loading: false,
  session: {
    token: null,
    refreshToken: null,
    userIri: null,
    roles: [],
  },
  feedback: {
    show: false,
    message: '',
    color: 'info',
  },
  items: [
    {
      title: 'Dashboard',
      icon: 'mdi-view-dashboard',
      to: {
        name: 'Dashboard',
      },
    },
    {
      title: 'Usuários',
      icon: 'mdi-account',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'Users',
      },
    },
    {
      title: 'Revisar vídeos',
      icon: 'mdi-youtube',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'VideoReviews',
      },
    },
    {
      title: 'Modalidades de ensino',
      icon: 'mdi-school',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'Modalities',
      },
    },
    {
      title: 'Especializações',
      icon: 'mdi-school',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'Specializations',
      },
    },
    {
      title: 'Compras de aulas',
      icon: 'mdi-store',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'Orders',
      },
    },
    {
      title: 'Pacotes - Descrições',
      icon: 'mdi-school',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'Plans',
      },
    },
    {
      title: 'Cupons para pacotes',
      icon: 'mdi-ticket-percent',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'PlanCoupons',
      },
    },
    {
      title: 'Cupons de desconto',
      icon: 'mdi-ticket-percent',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'DiscountCoupons',
      },
    },
    {
      title: 'Compras de pacotes',
      icon: 'mdi-school',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'Subscriptions',
      },
    },
    {
      title: 'Templates de mensagem',
      icon: 'mdi-email',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'MessageTemplates',
      },
    },
    {
      title: 'Depoimentos',
      icon: 'mdi-comment-text',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'Reviews',
      },
    },
    {
      title: 'FAQ',
      icon: 'mdi-help-circle',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'Faqs',
      },
    },
    {
      title: 'Convites',
      icon: 'mdi-mail',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'Invites',
      },
    },
    {
      title: 'Depoimentos da Home',
      icon: 'mdi-chat',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'Testimonials',
      },
    },
    {
      title: 'Termos de Uso',
      icon: 'mdi-file-document-edit',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'TermsOfUse',
      },
    },
    {
      title: 'Política de Privacidade',
      icon: 'mdi-file-document-edit',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'PrivacyPolicy',
      },
    },
    {
      title: 'Configurações',
      icon: 'mdi-cog',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'Settings',
      },
    },
    {
      title: 'Relatório de vendas',
      icon: 'mdi-chart-line',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'OrderReport',
      },
    },
    {
      title: 'Categorias do blog',
      icon: 'mdi-pencil',
      roles: ['ROLE_ADMIN', 'ROLE_EDITOR'],
      to: {
        name: 'BlogCategories',
      },
    },
    {
      title: 'Publicações do blog',
      icon: 'mdi-pencil',
      roles: ['ROLE_ADMIN', 'ROLE_EDITOR'],
      to: {
        name: 'BlogPosts',
      },
    },
    {
      title: 'Redirecionamentos do blog',
      icon: 'mdi-chat',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'Redirects',
      },
    },
    {
      title: 'Avisos na home',
      icon: 'mdi-pencil',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'DashboardNotifications',
      },
    },
    {
      title: 'Acessos',
      icon: 'mdi-laptop',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'Accesses',
      },
    },
    {
      title: 'Conteúdo',
      icon: 'mdi-text',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'Content',
      },
    },
    {
      title: 'Traffic Lights - Infrações',
      icon: 'mdi-traffic-light',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'TrafficLightEvents',
      },
    },
    {
      title: 'Mensagens de contato',
      icon: 'mdi-chat',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'ContactMessages',
      },
    },
    {
      title: 'Páginas',
      icon: 'mdi-file-document',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'Pages',
      },
    },
    {
      title: 'Blocos',
      icon: 'mdi-file-document',
      roles: ['ROLE_ADMIN'],
      to: {
        name: 'Blocks',
      },
    },
  ],
}

const mutations = {
  ...make.mutations(state),
  set (state, [variable, value]) {
    state[variable] = value
  },
  startLoading (state) {
    state.loading = true
  },
  stopLoading (state) {
    state.loading = false
  },
  setSessionToken (state, token) {
    state.session.token = token
  },
  setSessionRefreshToken (state, refreshToken) {
    state.session.refreshToken = refreshToken
  },
  setUserIri (state, iri) {
    state.session.userIri = iri
  },
  setRoles (state, roles) {
    state.session.roles = roles
  },
  unsetTokens (state) {
    state.session = {
      token: null,
      refreshToken: null,
      userIri: null,
    }
  },
  raiseSuccess (state, message) {
    state.feedback = {
      message: message,
      color: 'success',
      show: true,
    }
  },
  raiseError (state, message) {
    state.feedback = {
      message: message,
      color: 'error',
      show: true,
    }
  },
}

const actions = {
  ...make.actions(state),
  checkSession: function (context) {
    const api = getApiClient(context)

    api.get('/users/me')
      .catch((error) => {
        if (error.response.status === 401) {
          context.dispatch('refreshToken')
        }
      })
  },
  refreshToken: function (context) {
    const api = getApiClient(context)
    const session = context.state.session

    context.commit('setSessionToken', null)

    return new Promise((resolve, reject) => {
      if (session.refreshToken) {
        api.post('auth/refresh', {
          refresh_token: session.refreshToken,
        })
          .then((response) => {
            const data = response.data
            context.commit('setSessionToken', data.token)
            context.commit('setSessionRefreshToken', data.refresh_token)
            resolve(data)
          })
          .catch((error) => {
            context.commit('unsetTokens')
            reject(new Error(error))
          })
      } else {
        reject(new Error('No token available'))
      }
    })
  },
  init: async ({ dispatch }) => {
    //
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
